// DEPENDENCIES
import React from 'react'
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg';
import * as draftToHtml from 'draftjs-to-html';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';
import ContentHeader from './ContentHeader';

const TextEditorBlock = (props) => {
    let state = {
        editorState: EditorState.createWithContent(
            ContentState.createFromBlockArray(
                convertFromHTML(props.value)
            )
        )
    };

    return (
        <>
            <CustomBlock className="input-block-container">
                {
                    props.inputLabel ?
                        <span className={`static-floating-label ${props.inputState}`}>
                            {props.inputLabel}
                        </span> : <></>
                }
                <CustomBlock className={`text-editor-block-container ${props.bordered ? "bordered" : ""}`}>

                    <Editor
                        {...props}
                        toolbar={{ options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'image', 'remove', 'history'] }}
                        defaultEditorState={state.editorState}
                        onEditorStateChange={(state) => {
                            props.changeText(draftToHtml(convertToRaw(state.getCurrentContent())).replace("<ins>", "<u>").replace("</ins>", "</u>"));
                        }}
                        wrapperClassName="text-editor-block-wrapper"
                        editorClassName="text-editor-block-editor"
                        toolbarClassName="text-editor-block-toolbar"
                    />
                </CustomBlock>
            </CustomBlock>
        </>
    )
}

export default TextEditorBlock;